
import React from "react";
import { Grid, GridColumn, GridRow } from "sprint-common-web";

import { OrderAirlinesDataProvider } from "../../common/data-providers/OrderAirlinesDataProvider";
import { OrderRequestAssetsSection } from "./assets/OrderRequestAssetsSection";
import { OrderRequestDeliverySection } from "./delivery/OrderRequestDeliverySection";
import { OrderRequestDetailsSection } from "./details/OrderRequestDetailsSection";
import { OrderRequestMaterialSpecificationSection } from "./material-specification/OrderRequestMaterialSpecificationSection";
import { OrderRequestDashboardHeader } from "./OrderRequestDashboardHeader";

export const OrderRequestDashboard = (): JSX.Element => {
    return (
        <>
            <OrderRequestDashboardHeader />
            <Grid>
                <GridRow style={{ display: "flex", alignItems: "stretch" }}>
                    <GridColumn sm={6} style={{ display: "flex" }}>
                        <OrderRequestDetailsSection minHeight={400} />
                    </GridColumn>
                    <GridColumn sm={6} style={{ display: "flex" }}>
                        <OrderRequestDeliverySection minHeight={400} />
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <OrderAirlinesDataProvider>
                        <GridColumn sm={12}>
                            <OrderRequestAssetsSection minHeight={400} />
                        </GridColumn>
                    </OrderAirlinesDataProvider>
                </GridRow>
                <GridRow>
                    <GridColumn sm={12}>
                        <OrderRequestMaterialSpecificationSection minHeight={400} />
                    </GridColumn>
                </GridRow>
            </Grid>
        </>
    );
};
